import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Person } from '@reg/shared/model/person.model';
import { IdentityPerson, Wrestler } from '@reg/shared/model';

/**
 * Component used to handle date of birth entry and masking
 */
@Component({
    selector: 'flo-person-dob',
    templateUrl: './person-dob.component.html',
})
export class PersonDobComponent {
    @Output() public dateChange: EventEmitter<Date> = new EventEmitter<Date>();
    @ViewChild('dob') public dateOfBirthInput: NgModel;
    @Input() public required: boolean = false;

    @Input()
    public set wrestler(wrestler: Wrestler) {
        this._wrestler = wrestler;
        this.updateMaskDateOfBirth();
        this.setPersonToUpdate();
    }

    public get wrestler(): Wrestler {
        return this._wrestler;
    }

    @Input()
    public set identityPerson(identityPerson: IdentityPerson) {
        this._identityPerson = identityPerson;
        this.updateMaskDateOfBirth();
        this.setPersonToUpdate();
    }

    public get identityPerson(): IdentityPerson {
        return this._identityPerson;
    }

    @Input()
    public set isSubmitted(isSubmitted: boolean) {
        if (this._isSubmitted && !isSubmitted) {
            this.reset();
        }

        this._isSubmitted = isSubmitted;
    }

    public get isSubmitted(): boolean {
        return this._isSubmitted;
    }

    public maskDateOfBirth: boolean = false;
    private _wrestler: Wrestler = null;
    private _identityPerson: IdentityPerson = null;
    public person: Person = new Person();
    private _isSubmitted: boolean = false;

    public isValid(): boolean {
        return this.maskDateOfBirth || (this.dateOfBirthInput && this.dateOfBirthInput.valid);
    }

    public reset(): void {
        this.person.dateOfBirth = null;

        if (this.dateOfBirthInput) {
            this.dateOfBirthInput.reset();
        }
    }

    public onDateOfBirthChange(): void {
        this.dateChange.emit(this.person.dateOfBirth);
    }

    /**
     * Determine if the date of birth should be masked or not
     */
    private updateMaskDateOfBirth(): void {
        const previouslyMasked: boolean = this.maskDateOfBirth;
        this.maskDateOfBirth = false;

        if (this.wrestler && this.wrestler.dateOfBirth && this.wrestler.identityPersonId) {
            this.maskDateOfBirth = true;
        } else {
            this.maskDateOfBirth = (this.identityPerson && this.identityPerson.id && !!this.identityPerson.dateOfBirth);
        }

        if (previouslyMasked && !this.maskDateOfBirth) {
            this.reset();
        }
    }

    /**
     * A wrestler record takes priority over an identityPerson so we update the wrestler
     * record if it's provided. It's provided during event registration and and event management
     */
    private setPersonToUpdate(): void {
        this.person = this.wrestler ? this.wrestler : this.identityPerson;
        this.person = this.person || new Person();
    }
}
